import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Ticket, 
  Wrench,
  Menu
} from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * Mobile Bottom Navigation Bar
 * Visible only on mobile devices (hidden on md and above)
 */
export default function MobileBottomNav({ onMenuClick }) {
  const location = useLocation();

  const navItems = [
    { to: '/', icon: LayoutDashboard, label: 'Home' },
    { to: '/tecnico', icon: Wrench, label: 'Tecnico' },
    { to: '/tickets', icon: Ticket, label: 'Tickets' },
    { to: '/clienti', icon: Users, label: 'Clienti' },
    { type: 'menu', icon: Menu, label: 'Menu', action: onMenuClick },
  ];

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 h-16 bg-slate-900 dark:bg-slate-950 border-t border-slate-800 md:hidden z-50 safe-area-inset-bottom"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-stretch justify-around h-full">
        {navItems.map((item, index) => {
          const Icon = item.icon;
          
          if (item.type === 'menu') {
            return (
              <button
                key="menu"
                onClick={item.action}
                className="flex flex-col items-center justify-center flex-1 text-slate-400 hover:text-white active:bg-slate-800 transition-colors touch-manipulation"
                data-testid="mobile-nav-menu"
              >
                <Icon className="h-5 w-5 mb-0.5" />
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            );
          }

          const isActive = location.pathname === item.to || 
            (item.to !== '/' && location.pathname.startsWith(item.to));

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={cn(
                "flex flex-col items-center justify-center flex-1 transition-colors touch-manipulation",
                isActive 
                  ? "text-cyan-400 bg-cyan-500/10" 
                  : "text-slate-400 hover:text-white active:bg-slate-800"
              )}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <Icon className={cn("h-5 w-5 mb-0.5", isActive && "text-cyan-400")} />
              <span className={cn(
                "text-[10px] font-medium",
                isActive && "text-cyan-400"
              )}>{item.label}</span>
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-cyan-400 rounded-full" />
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
